//include 4 
jQuery(function(){
    var privateFunctions = {
        generateReloadUrl: (cid, pid, additionalParams) => {
            var domainReloadParameters = window.pixelpoint.utilities.getSysPageUrl();
            var parsed = window.pixelpoint.utilities.parseUrl(window.location.href);
            parsed.baseUrl = domainReloadParameters.baseUrl;//`${window.location.protocol}//${window.location.hostname}${window.location.port ? ':' + window.location.port : ''}`;//window.location.origin;
            
            additionalParams = additionalParams || [];
            $.each(additionalParams, (index, param) => {
                parsed.queryParameters[index] = param;
            });
            if(domainReloadParameters.useAjaxRenderPageId)
                parsed.queryParameters.id = domainReloadParameters.ajaxRenderPageId;
            //parsed.queryParameters.id = window.pixelpoint.domainService.get("ajaxRenderPage");//1568;
            parsed.queryParameters.cid = cid;
            parsed.queryParameters.pid = pid;            
            parsed.queryParameters.no_cache = 1;

            var offCanvasWrapper = $(".off-canvas-wrapper");
            var language = offCanvasWrapper.data("lang") || 0;
            if(!!language){
                parsed.queryParameters.L = language;
            }
            
            if (!!parsed.queryParameters['cHash'])
                delete parsed.queryParameters['cHash'];
            return window.pixelpoint.utilities.buildUrl(parsed);
        },
        loader: $element => {
            let loader = $element.find('.loader[data-loader]');
            if(loader.length == 0){
                let cid = $element.data("cid");
                let pid = $element.data("pid");
                loader = $(`<div class="loader absolute hidden" data-loader data-name="module-${cid}-${pid}-loader"></div>`).appendTo($element);
                window.pixelpoint.ppComponents.loader(loader);
            }
            if(!loader.data("exposed")){
                window.pixelpoint.ppComponents.loader(loader);
            }
            return loader;          
        },
        showLoader: $element => {
            privateFunctions.loader($element).data("exposed").show();
        },
        hideLoader: $element => {
            privateFunctions.loader($element).data("exposed").hide();
        },
        initializeComponents: $element => {
            window.pixelpoint.images.initializeErrors($element);
            $element.find('.offers-gallery.slick-slider').each(function () {
                if(!$(this).hasClass("slick-initialized")){
                    console.log("Offers slider will be initialized after module reload...")
                    window.ppComponents.sliders.offersGallery.init($(this));
                }
            });
            $element.find("[data-responsive-accordion-tabs]").each(function(){
                new Foundation.ResponsiveAccordionTabs($(this), {});
            });
            if($element.find("img.lazy").length > 0){
                window.pixelpoint.lazy.init($element.find("img.lazy"));
            }
            window.pixelpoint.lazy.initInterchange($element.find("[data-lazy-interchange]"));
            $element.find(".more-wrapper").each(function(){
                window.ppComponents.common.showMore($(this));
            });
            window.pixelpoint.initOpeningHoursText(); 

            if($element.find(".tabgallery-wrapper").length > 0){                
                window.pixelpoint.map.async.checkMedium()
                .done(function(){
                    if($element.find("ppcarto-map-medium").length > 0){
                        window.ppcartoMedium = new Vue({
                            el: '#ppcarto-medium'
                        });
                        window.pixelpoint.map.promises.mediumMapLoaded.resolve();
                    }
                    window.ppComponents.sliders.tabGallery.initTabClickEvents();
                    window.ppComponents.sliders.tabGallery.initWrapper();
                    //window.ppComponents.sliders.tabGallery.init(true);
                });                
            }

            $element.find(".tabs-container, .tabs").on("change.zf.tabs", function(event, tab) {
                var tabId = tab.find("a").attr("href");
                var tabPanel = $(tabId);
                if (tabPanel.length > 0) {
                    window.pixelpoint.lazy.init(tabPanel.find(".lazy"));
                    window.pixelpoint.lazy.initInterchange(
                        tabPanel.find("[data-lazy-interchange]")
                    );
                }
            });
        },
        reload: (elements, hideLoader, cback) => {
            elements.each((index,element) => {
                let $element = $(element);
                let cid = $element.data("cid");
                let pid = $element.data("pid");
                if(!cid || !pid)
                    return true;
                hideLoader = hideLoader || false;
                
                var additionalParams = $element.data("get-params") || {};

                let url = privateFunctions.generateReloadUrl(cid, pid, additionalParams);

                if($element.css("position") == 'static'){
                    $element.css({"position":"relative"});
                }

                if(!hideLoader) {
                    privateFunctions.showLoader($element);
                }

                if(!cback){
                    cback = function(data, localcid, $localElement){
                        var parsedContent = $('<output>').append($.parseHTML(data));
                        var loadedElement = parsedContent.find(`[data-cid='${localcid}']`);
                        $localElement.html(loadedElement.html());
                        privateFunctions.initializeComponents($localElement);

                        /*
                        $element.find(".lazy").each(function(){
                            if($(this).data("src")){
                                var newSrc = $(this).data("src");
                                $(this).attr("src",newSrc);
                            }
                        });
                        */
                    }
                }
                var localCid = cid;
                var $localElement = $element;
                $.ajax({
                    url:url
                }).done((data) => {
                    cback(data, localCid, $localElement);
                }).always(function(){
                    if(!hideLoader) {
                        privateFunctions.hideLoader($localElement);
                    }

                    checkForItemWithBanderole();

                    let $childrenWithShowMore = $localElement.find('.showmore');

                    if($childrenWithShowMore.length > 0){
                        $childrenWithShowMore.each(function () {
                            window.pixelpoint.ppComponents.showMore.init($(this));
                        });
                    }
                });
            });
        }
    };
    window.pixelpoint.ppComponents.module = {
        reload: privateFunctions.reload
    };
    window.pixelpoint.ppComponents.module.reload($("[data-reload-module]"),false,null);


});